import { boolean, object, string } from "yup";
import { StatusEnum } from "../../shared";

export const DEFAULT_VALUES = {
  status: StatusEnum.ACTIVE,
  role: "",
  company: null,
  accountingActionChartOfAccounts: {},
  sellerBankAccounts: [],
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  address: string().required("Harus diisi"),
  whatsapp: string().required("Harus diisi"),
  role: string().required("Peran harus dipilih"),
  status: boolean().required("Harus diisi"),
});
